import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'timeInTimezone',
})
export class TimeInTimezonePipe implements PipeTransform {
  public transform(value: string | Date, timezone: string, format: string = 'h:mma ZZZZ'): string {
    if (!value || !timezone) {
      return undefined;
    }

    if (typeof value === 'string' || value instanceof String) {
      return DateTime.fromISO(value as string)
        .setZone(timezone)
        .toFormat(format);
    } else {
      return DateTime.fromJSDate(value as Date)
        .setZone(timezone)
        .toFormat(format);
    }
  }
}
